import { ChainId } from '@/lib/chain'
import { TEnvConfig } from './env.interfact'
import { DEV_CONFIG } from './dev'

export const LOCAL_CONFIG: TEnvConfig = {
  ...DEV_CONFIG,
  supportedChains: [ChainId.ETHEREUM, ChainId.OPTIMISM, ChainId.BSC],
  defaultChainId: ChainId.OPTIMISM,
  kulapPlusApiBaseUrl: 'http://localhost:3001/api/v1',
  kulapPlusUtilityFileUrl:
    'https://kulap-plus-utility-file-dev.s3.ap-southeast-1.amazonaws.com',
  kulapPlusTokenListFilePath: {
    [ChainId.ETHEREUM]: '/token-lists/ethereum.json',
    [ChainId.OPTIMISM]: '/token-lists/optimism.json',
    [ChainId.BSC]: '/token-lists/bsc.json'
  },
  kulapSwapFrontendUrl: 'http://alpha.kulap.io/#',
  kulapPlusFrontendUrl: 'http://localhost:8081',
  googleRecaptcha: '6Ld_pMUZAAAAAM5Pajn7kxKwQRbJGoqIRb3axu7Y',
  initFromFiatCurrencyAmount: '5',
  checkUserEligibilityTrade: false,
  // depositSwapContractAddresses: {
  //   [ChainId.ETHEREUM]: '0x07fb010B623028bF997E2c6Ca997C21604710Dcf',
  //   [ChainId.BSC]: '0x07fb010B623028bF997E2c6Ca997C21604710Dcf',
  //   [ChainId.OPTIMISM]: '0x07fb010B623028bF997E2c6Ca997C21604710Dcf'
  // },
  thaiD: {
    apiEndpoint: 'https://imauthsbx.bora.dopa.go.th/api/v2',
    clientId: 'TEt6RzU3cGlRSXc4enJMOGtuMlVyR1JiSHd0VDk0SjI',
    redirectUri: 'http://localhost:3001/api/v1/kyc-provider/thaid/callback'
  }
}
